// extracted by mini-css-extract-plugin
module.exports = {"delete-button":"deletebutton_delete-button__1e-5k"};